import AccessibilityUtilities from "./utilities/accessibility.js";
import urlParameterTrackingInit from "./utilities/url-parameter-tracking.ts";
import cardsInit from "./components/card.ts";
import accordionInit from "./components/accordion.ts";
import carouselInit from "./components/carousel.ts";
import siteHeaderInit from "./components/site-header.ts";
import videoEmbedInit from "./components/video-embed.ts";
import modalInit from "./components/modal.ts";
import cookieBarInit from "./components/cookies.ts";
import homeHeroInit from "./components/home-hero.ts";
import homeAnimationsInit from "./pages/home-animations.ts";

// Import the main CSS file for the application (keep this line here after other imports)
import "../css/index.css";

document.addEventListener("DOMContentLoaded", () => {
  AccessibilityUtilities.init();
  urlParameterTrackingInit();
  cardsInit();
  accordionInit();
  carouselInit();
  modalInit();
  videoEmbedInit();
  siteHeaderInit();
  cookieBarInit();
  homeHeroInit();
  homeAnimationsInit();
});
